module.exports = __webpack_public_path__ + "static/media/RB_Default_RGB.11b3c184.svg";